// export const API_BASE_URL = "http://localhost:1337";
// export const BASE_URL = "http://localhost:1337/api/";
export const API_BASE_URL = "https://strapi.sellomate.com";
export const BASE_URL = "https://strapi.sellomate.com/api/";
